// Function to be called from the add to cart button or any other event that updates the cart value
// function updateDeliveryThreshold(currentCartValue) {
//   const deliveryThresholdContainer = document.querySelectorAll('.delivery-threshold');
//   console.log(deliveryThresholdContainer);
//   if (!deliveryThresholdContainer.length) return;

//   deliveryThresholdContainer.forEach((container) => {
//     const progressBar = container.querySelector('.delivery-threshold__progress-bar');
//     const labelValue = container.querySelector('.delivery-threshold__label-value');

//     const maxValue = parseFloat(progressBar.max);
//     const remaining = Math.max(0, maxValue - currentCartValue);

//     // Update progress bar
//     progressBar.value = currentCartValue;
//     progressBar.setAttribute('aria-valuenow', currentCartValue.toFixed(2));

//     if (remaining > 0) {
//       // labelValue.innerText = remaining.toFixed(2);
//       container.classList.remove('delivery-threshold-complete');
//       container.classList.add('delivery-threshold-incomplete');
//     } else {
//       container.classList.add('delivery-threshold-complete');
//       container.classList.remove('delivery-threshold-incomplete');
//     }
//   });
// }
function updateDeliveryThreshold(stage, cartValue, thresholdValue) {
  const barWrappers = document.querySelectorAll('.progress-bar-wrapper');
  if (!barWrappers.length) return;

  barWrappers.forEach((barWrapper) => {
    const fill = barWrapper.querySelector('.progress-bar-fill');
    const steps = barWrapper.querySelectorAll('.progress-step');

    // Fill logic
    let width = 0;
    if (stage === 0) {
      // proportional progress until £30 → 0–50%
      width = Math.min((cartValue / thresholdValue) * 50, 50);
    } else if (stage === 1) {
      width = 50; // lock at halfway
    } else if (stage === 2) {
      width = 100; // full
    }
    if (fill) {
      fill.style.width = width + '%';
    }

    // Step states
    steps.forEach((step, index) => {
      if (index + 1 <= stage) {
        step.classList.add('complete');
      } else {
        step.classList.remove('complete');
      }
    });

    // Dynamic label inside this wrapper (if present)
    const label = barWrapper.parentElement.querySelector('.delivery-threshold__label p');
    if (label) {
      if (stage === 0) {
        const difference = Math.max(0, thresholdValue - cartValue);
        label.textContent = `Spend £${difference.toFixed(0)} to get FREE Economy Shipping`;
      } else if (stage === 1) {
        label.textContent = `Add Shampoo, Conditioner or Mask & unlock FREE Express Shipping`;
      } else if (stage === 2) {
        label.textContent = `You qualify for FREE Express Shipping`;
      }
    }
  });
}




